/**
 * desc : 图片展示样式-平滑
 */
<template>
  <section class="comp-image-slide swiper-container" :style="`background-color: ${backgroundColor}`">
    <div class="swiper-wrapper">
      <div v-for="(image, index) in imgs" :key="index" data-actionid="1" data-itemtext="图片类组件" :data-itemotherinfo="getLink(image)" @click="clickHandle(image, index)" class="swiper-slide" v-show="image.show">
        <img width="100%" :src="`${picHost+image.imgLink}`" @load="loadHandler">
      </div>
      <div class="swiper-pagination"></div>
    </div>
  </section>
</template>
<script>
import mixin from './image_mixin.js'
import { eventBus } from '@/utils'

export default {
  mixins: [mixin],
  watch: {
    compProps: {
      handler(newVal, oldVal) {
        if (newVal !== oldVal) {
          this.$nextTick(() => {
            let space = 0
            const width = document.body.clientWidth
            if (width <= 720) {
              space = width / 375 * 20
            } else {
              space = 40
            }
            // eslint-disable-next-line
            this.swiper = new Swiper(`#comp_id_${this.compId} .comp-image-slide`, {
              slidesPerView: 'auto',
              spaceBetween: space
            })
          })
        }
      }
    }
  },
  computed: {
    backgroundColor() {
      if (this.compProps.privateProps) {
        return this.compProps.privateProps.backgroundColor
      }
    }
  },
  methods: {
    loadHandler($event) {
      eventBus.$emit('imageOnload')
    }
  }
}
</script>
<style lang="scss" scoped>
.comp-image-slide {
  padding-left: 1.3333rem;
  padding-right: 1.3333rem;
  // border-radius: 0.4rem;
  img {
    border-radius: 0.4rem;
    cursor: pointer;
    pointer-events: none;
    -webkit-user-select: none;
    -moz-user-select: none;
    user-select: none;
  }

  :global(.swiper-slide) {
    width: 19.8rem;
  }

  @media screen and (min-width: 720px) {
    :global(.swiper-slide) {
      width: 80%;
    }
  }
}
</style>
